import { useEffect, useState } from "react";
import { get, post } from "../../redux/ApiHelper";
import TableComponent from "../../components/table/TableComponent";
import { Column } from "../../interfaces/table.interface";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { TeacherDetailsAccessRequestInterface } from "../../interfaces/teacher-details-access.interface";

const AccessDetails = () => {
  const [originalList, setOriginalList] = useState<
    TeacherDetailsAccessRequestInterface[]
  >([]);
  const [requestAccessList, setRequestAccessList] = useState<
    TeacherDetailsAccessRequestInterface[]
  >([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { signedAdmin } = useSelector((state: RootState) => state.admin);
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  console.log(signedAdmin);
  useEffect(() => {
    const queryParams = new URLSearchParams();
    if (signedAdmin.role === "super-admin") {
      queryParams.set("adminId", String(signedAdmin.email));
    } else {
      queryParams.set("adminId", String(signedAdmin.id));
    }
    queryParams.set("type", String(signedAdmin.type));
    get(`/admin/teacher/all-access-requests?${queryParams.toString()}`).then(
      (res) => {
        setOriginalList(res.accessDocuments);
        setRequestAccessList(res.accessDocuments);
      }
    );
  }, [isApproving, isRejecting]);
  // console.log(parentList);
  const handleSearch = () => {
    // if (!searchQuery) {
    //   if (signedAdmin.type === "franchise") {
    //     setRequestAccessList([]);
    //     return;
    //   }
    //   setRequestAccessList(originalList);
    //   return;
    // }
    const filteredList = originalList.filter((request) => {
      const lowerQuery = searchQuery.toLowerCase();
      return (
        request.teacherId.phoneNumber
          .toString()
          .toLowerCase()
          .includes(lowerQuery) || // exact match
        request.teacherId.email?.toLowerCase().includes(lowerQuery) ||
        request.teacherId.name?.toLowerCase().includes(lowerQuery) ||
        request.adminId.email?.toLowerCase().includes(lowerQuery) ||
        request.adminId.name?.toLowerCase().includes(lowerQuery) ||
        request.teacherId._id?.toLowerCase().includes(lowerQuery) ||
        request.adminId._id?.toLowerCase().includes(lowerQuery)
      );
    });
    setRequestAccessList(filteredList);
  };

  useEffect(() => {
    handleSearch();
  }, [searchQuery]);

  const columns: Column[] = [
    {
      header: "Admin name",
      render: (value, row: TeacherDetailsAccessRequestInterface) =>
        `${row.adminId.name}`,
    },
    {
      header: "Admin Email",
      render: (value, row: TeacherDetailsAccessRequestInterface) =>
        `${row.adminId.email}`,
    },
    {
      header: "Admin PhoneNo",
      render: (value, row: TeacherDetailsAccessRequestInterface) =>
        `${row.adminId.phoneNumber}`,
    },
    {
      header: "Teacher name",
      render: (value, row: TeacherDetailsAccessRequestInterface) =>
        `${row.teacherId.name}`,
    },
    {
      header: "Teacher Email",
      render: (value, row: TeacherDetailsAccessRequestInterface) =>
        `${row.teacherId.email}`,
    },
    {
      header: "Teacher phoneNumber",
      render: (value, row: TeacherDetailsAccessRequestInterface) =>
        `${row.teacherId.phoneNumber}`,
    },
    {
      header: "Action",
      render: (value, row: TeacherDetailsAccessRequestInterface) => {
        const handleAction = async (action: string) => {
          try {
            if (action === "accepted") {
              setIsApproving(true);
            } else {
              setIsRejecting(true);
            }

            await post("/admin/teacher/request-action", {
              adminId:
                signedAdmin.role === "super-admin"
                  ? signedAdmin.email
                  : signedAdmin.id,
              type: signedAdmin.type,
              action,
              id: row._id,
            });
          } catch (error) {
            // Handle error if needed
          }
          setIsApproving(false);
          setIsRejecting(false);
        };

        const getStatusColor = (status: string) => {
          switch (status) {
            case "pending":
              return "text-yellow-500";
            case "accepted":
              return "text-green-600";
            case "rejected":
              return "text-red-500";
            default:
              return "text-gray-500";
          }
        };

        return (
          <div>
            {row.accessRequest === "pending" ? (
              <div className="flex gap-2">
                <button
                  onClick={() => handleAction("accepted")}
                  className="text-green-600 hover:underline bg-gray-200"
                >
                  {isApproving ? "Approving" : "Approve"}
                </button>
                <button
                  onClick={() => handleAction("rejected")}
                  className="text-red-500 hover:underline bg-gray-200"
                >
                  {isRejecting ? "Rejecting" : "Reject"}
                </button>
              </div>
            ) : (
              <div className={getStatusColor(row.accessRequest)}>
                {row.accessRequest.charAt(0).toUpperCase() +
                  row.accessRequest.slice(1)}
              </div>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="parent table-container">
      <div className="title">Teacher details access requests</div>
      <div className="search-container mb-4">
        <input
          type="text"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm"
          placeholder={
            signedAdmin.type === "franchise"
              ? "Search by name, email or phoneNumber"
              : "Search request"
          }
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value.trim())}
        />
      </div>
      <TableComponent columns={columns} data={requestAccessList} />
    </div>
  );
};

export default AccessDetails;
